// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/ConfiguracoesSistema_ListResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/configuracoes_sistema/list.
 *
 * dados is the full list of system configuration rows
 * (Configuracoes_sistema_model::list — `SELECT * FROM config_sistema`).
 */
import type { ConfiguracoesSistema_ListRow } from './ConfiguracoesSistema_ListRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type ConfiguracoesSistema_ListResponseDados = ConfiguracoesSistema_ListRow[];

export type ConfiguracoesSistema_ListResponse = ApiResponse<ConfiguracoesSistema_ListResponseDados>;

registerResponseContract('ConfiguracoesSistema_ListResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      config_sistema_id: { type: 'string',  required: false },
      nome:              { type: 'string',  required: true },
      titulo:            { type: 'string',  required: false },
      descricao:         { type: 'string',  required: false },
      categoria:         { type: 'string',  required: false },
      valor_padrao:      { type: 'string',  required: false },
    },
  },
})
